// The viewer's access to the locked videos, by collection (Clerk publicMetadata.videoAccess;
// fullstack claude/VIDEOS.md): Workshop (workshopVideosUntil) and Masterclass
// (masterclassVideosUntil), each unlocked while its year has not passed; an expired one counts as
// locked. accessState: "none", "partial" (one of the two) or "full". The user is read again when
// the page comes back into view (a tab, the return from paying), so new access shows without a
// reload, as the video page's lookup does (Video/Bespoke.vue).
import {getVideoAccessNow} from "@/composables/videoAccessNow";
import {computed} from "vue";
import {useEventListener} from "@vueuse/core";
import useUserSafe from "@/composables/useUserSafe";

const CURRENT_YEAR = new Date().getFullYear();
const COLLECTIONS = {workshop: "workshopVideosUntil", masterclass: "masterclassVideosUntil"};

export function getHasCollectionAccess(videoAccess, collection) {
  return (Number(videoAccess?.[COLLECTIONS[collection]]) || 0) >= CURRENT_YEAR;
}

function getAccessState(hasWorkshopAccess, hasMasterclassAccess) {
  if (hasWorkshopAccess && hasMasterclassAccess) return "full";
  if (hasWorkshopAccess || hasMasterclassAccess) return "partial";
  return "none";
}

export default function useVideoAccess() {
  const {user} = useUserSafe();
  const videoAccess = computed(() => getVideoAccessNow(user.value?.publicMetadata?.videoAccess));
  const hasWorkshopAccess = computed(() => getHasCollectionAccess(videoAccess.value, "workshop"));
  const hasMasterclassAccess = computed(() => {
    return getHasCollectionAccess(videoAccess.value, "masterclass");
  });
  const accessState = computed(() => {
    return getAccessState(hasWorkshopAccess.value, hasMasterclassAccess.value);
  });
  const reloadUser = () => {
    if (document.visibilityState !== "visible" || accessState.value === "full") return;
    user.value?.reload().catch(() => {});
  };
  useEventListener(document, "visibilitychange", reloadUser);
  useEventListener(window, "focus", reloadUser);
  return {hasWorkshopAccess, hasMasterclassAccess, accessState};
}
